import PriceInput from "../../../../components/general/PriceInput";
import { useTranslation } from "react-i18next";

interface DynamicPriceInputProps {
  label: string;
  value: number;
  setValue: (value: number) => void;
  submittedOnce: boolean;
}

const DynamicPriceInput = (props: DynamicPriceInputProps) => {

  const { t } = useTranslation();

  return (
    <PriceInput
      size="small"
      label={`${props.label} *`}
      placeholder={t("components.dynamicPriceInput.placeholder")}
      value={props.value}
      onChange={(e) => props.setValue(Number(e.target.value))}
      error={props.value < 1 && props.submittedOnce}
      helperText={
        props.value < 1 &&
        props.submittedOnce &&
        t("components.dynamicPriceInput.errorGreaterThanZero")
      }
      autoComplete="off"
      fullWidth
    />
  );
};

export default DynamicPriceInput;
